import React from 'react';
import { useTranslations } from '@lang';

export const NumberOfGuests = ({ hasEnoughQuantity, maximumGuests, minimumGuests, typeName }) => {
  const { t } = useTranslations();

  return (
    <>
      {hasEnoughQuantity
        ? maximumGuests !== minimumGuests
          ? t('common.spaTreatmentCanBeBooked', { minimumGuests, maximumGuests, typeName })
          : t('common.spaTreatmentCanBeBookedSingleAmount', {
              guestAmount: maximumGuests,
              typeName,
            })
        : t('common.spaTreatmentNoQuantity', { typeName })}
    </>
  );
};
